import { MarketCode } from '../@types/MarketCode';
import { regexRegistrationNumberSE, regexEmail, regexRegistrationNumberNO } from './regex';

export const validationMethods = {
  requiredRegistrationNumber: (s?: string, marketCode?: MarketCode) => {
    if (!s || !marketCode) {
      return false;
    }

    const trimmed = s.replace(/\s+/g, '');

    const hasCorrectLength = trimmed.length === (marketCode === 'SE' ? 6 : 7);
    const isRegexMatch =
      marketCode === 'SE'
        ? regexRegistrationNumberSE.test(trimmed)
        : regexRegistrationNumberNO.test(trimmed);

    return hasCorrectLength && isRegexMatch;
  },
  requiredNumberGreaterOrEqualThanZero: (s?: string | number) => {
    if (s === undefined || s === null) {
      return false;
    }
    const f = parseInt(s.toString(), 10);
    return !isNaN(f) && f >= 0;
  },
  requiredCondition: (s?: string) => {
    return ['VeryGood', 'Good', 'Ok'].includes(s || '');
  },
  requiredString: (s?: string) => !!s,
  optionalString: (s?: string) => !s || !!s,
  requiredEmail: (s?: string | null) => regexEmail.test(s || ''),
};
